// extracted by mini-css-extract-plugin
module.exports = {"navigation-carousel":"NavigationCarousel_navigation-carousel__7RXpG","isSingle":"NavigationCarousel_isSingle__2K8pm"};